import { styled } from '@pata-app/themes';

export const SearchInputsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: ${({ theme }) => theme.core.sizing[1]}px;

  width: 100%;

  @media ${({ theme }) => `${theme.core.breakpoints.s}`} {
    flex-direction: row;
  }
`;

export const SearchInputWrapper = styled.div`
  position: relative;

  display: flex;
  flex-grow: 1;

  width: 100%;

  z-index: 2;

  &:last-of-type {
    z-index: 1;
  }

  > div {
    width: 100%;
  }

  > svg {
    position: absolute;
    top: 12px;
    left: 12px;
  }

  input {
    flex-grow: 1;
    padding-left: 40px;
    width: 100%;

    font-weight: ${({ theme }) => theme.core.fontWeight.regular};
    font-size: ${({ theme }) => theme.core.fontSizes.ml}px;

    border: none;

    outline-color: ${({ theme }) => theme.core.colors.primary.green.medium};
  }

  @media ${({ theme }) => `${theme.core.breakpoints.s}`} {
    &:last-of-type {
      border-left: 1px solid ${({ theme }) => theme.core.colors.greyscale.medium};
    }
    > svg {
      top: 8px;
      left: 12px;
    }
  }
`;

interface ICurrentLocation {
  isFetchingLocation: boolean;
}

export const CurrentLocation = styled.button<ICurrentLocation>`
  position: absolute;
  right: 0;
  top: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  height: 100%;

  background: transparent;
  border: none;

  cursor: pointer;

  svg {
    margin-right: ${({ isFetchingLocation }) => (isFetchingLocation ? '-12px' : '2px')};
  }
`;
